<div class="container">
  <img src="/assets/img/small-header.png" alt="Novels AI" style="width: 98%; display: block; margin: 0 auto;" />
  
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="container">
      <h1 class="display-4">Create Your Personalized AI-Generated Story</h1>
      <p class="lead">Where you are the hero! Experience immersive, AI-driven audiobooks tailored just for you.</p>
      
      <!-- <div class="mt-5">
        <iframe src="https://www.youtube-nocookie.com/embed/Ts4ksQNqwgM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div> -->
    </div>
  </section>

  <!-- Features Section -->
  <section id="features" class="py-5">
    <div class="container text-center">
      <h2>Why Choose Novels AI?</h2>
      <div class="row mt-4">
        <div class="col-md-4">
          <div class="feature-icons mb-3">
            <i class="bi bi-person-circle"></i>
          </div>
          <h5>Personalized Stories</h5>
          <p>Create your own adventure by customizing characters, settings, and more.</p>
        </div>
        <div class="col-md-4">
          <div class="feature-icons mb-3">
            <i class="bi bi-headphones"></i>
          </div>
          <h5>Immersive AI Narration</h5>
          <p>High-quality, realistic AI narration brings your story to life.</p>
        </div>
        <div class="col-md-4">
          <div class="feature-icons mb-3">
            <i class="bi bi-journal-bookmark"></i>
          </div>
          <h5>Endless Story Options</h5>
          <p>Choose from a variety of genres, from romance to sci-fi.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Screenshots Section -->
  <section class="bg-dark">
    <div class="container text-center py-3">
      <h2>Explore the Novels AI Experience</h2>
    </div>
    <table class="table table-dark table-striped table-bordered table-sm table-hover table-responsive">
      <tbody>
        @for (audiobook of (audiobooks); track audiobook) {
          <tr>
            <td 
            class="list-group-item d-flex justify-content-between align-items-start">
              <div class="d-flex flex-column w-100 p-2">
                <div class="fw-bold">
                  {{audiobook.title}} 
                  <div class="mt-2">
                    @for (chapter of (audiobook.chapters); track chapter; let idx = $index) {
                      <button 
                        type="button" 
                        class="btn btn-secondary btn-sm me-2"
                        (click)="onPlayPauseChapter(audiobook, chapter); $event.stopPropagation()"
                        >
                        <i
                            class="bi"
                            style="font-size: 1rem;"
                            [class.bi-play-circle]="!isPlayingCurrentChapter(audiobook, chapter)"
                            [class.bi-pause-circle]="isPlayingCurrentChapter(audiobook, chapter)"></i>
                          {{idx + 1}}
                      </button>
                    }
                  </div>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <div class="d-grid gap-2" style="margin-bottom: 15px;">
      <a class="btn btn-success" href="demo">Click here to listen to more demos</a>
    </div>
  </section>

  <!-- Pricing Section -->
  <section id="pricing" class="pricing-section text-center py-5">
    <div class="container" data-bs-theme="dark">
      <h2 class="mb-4">Simple & Transparent Pricing</h2>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <div class="card h-100 bg-dark border-primary">
            <div class="card-header bg-primary text-white">
              <h4 class="my-0">Free Trial</h4>
            </div>
            <div class="card-body">
              <h1 class="card-title">€0</h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>✨ 1 Free credit</li>
                <li>🎯 Create Your First Story</li>
                <li>🎧 AI Voice Narration</li>
                <li>♻️ Save story templates</li>
              </ul>
              <button type="button" class="btn btn-outline-primary btn-lg w-100" [routerLink]="['/register']">Get Started</button>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="card h-100 bg-dark border-success">
            <div class="card-header bg-success text-white">
              <h4 class="my-0">Pay As You Go</h4>
            </div>
            <div class="card-body">
              <h1 class="card-title">€5</h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>🎮 10 Credit</li>
                <li>🎯 Create Multiple Stories</li>
                <li>📖 Create Multiple Chapters</li>
                <li>💫 No Expiration</li>
                <li>🎥 Export 9:16 video with watermark</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="card h-100 bg-dark border-info">
            <div class="card-header bg-info text-white">
              <h4 class="my-0">Monthly Subscription</h4>
            </div>
            <div class="card-body">
              <h1 class="card-title">€6.99<small class="text-muted fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>✨ 20 Credits Monthly</li>
                <li>🎧 All Voice Options</li>
                <li>🗣️ Custom Voices</li>
                <li>💰 Subscriber Discounts</li>
                <li>🔄 Credits Roll Over</li>
                <li>🎥 Export 9:16 video without watermark</li>
                <li>🎙️ Export Novels in iTunes friendly format</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <p class="mt-4 text-muted">Each credit allows you to generate one chapter of your stories.</p>
    </div>
  </section>
  <img src="/assets/img/start.png" alt="Walking into Sci-fi world" style="max-width: 100%; min-width: 100%; margin-bottom: 15px;" />
  <p>
    Immerse yourself in the world of personalized AI-generated audiobooks with <strong>Novels AI</strong>. Our innovative app harnesses the power of artificial intelligence to create captivating stories with you as the main character! Experience your own adventures as the star of your unique novel, brought to life by state-of-the-art AI narration and voice synthesis technology.
  </p>
  <p>
      With <strong>Novels AI</strong>, you can explore endless storytelling possibilities across various genres, from romance and mystery to science fiction and fantasy. Customize your character, make choices that shape the plot, and dive into a one-of-a-kind listening experience tailored just for you.
  </p>
  <p>
      Whether you're looking to unwind with an engaging story, fuel your imagination, or simply experience the future of audiobooks, <strong>Novels AI</strong> is your gateway to an entirely new world of AI-powered storytelling. Embrace the magic of AI, and let the adventure begin!
  </p>
</div>
